import { ValueOf } from '@/types/util';

export const bankPayStatus = {
  NORMAL: '正常',
  ABNORMAL: '異常',
} as const;

export type BankPayStatusKey = keyof typeof bankPayStatus;
export type BankPayStatusValue = ValueOf<typeof bankPayStatus>;

export const bankPayStatusKeys = Object.keys(bankPayStatus) as BankPayStatusKey[];

/** v-select用items */
export const bankPayStatusItems = bankPayStatusKeys
  .map((key) => ({
    title: bankPayStatus[key],
    value: key,
  }));
